export default "__VITE_ASSET__CKN4Ttzd__"